<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { appRunUuidStorage } from '@nsftx/seven-client-retail-utils'
import { useDeviceManagementStore } from '@nsftx/seven-client-retail-vue-dm'
import { NXGRetailClock } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import SBOIdleTimerBar from './SBOIdleTimerBar.vue'

const appRunUuid = computed(() => appRunUuidStorage.getAppRunUuid() ?? '')
const { appData } = storeToRefs(useDeviceManagementStore())

const tenantName = computed(() => {
  if (!appData.value) return ''

  return appData.value.betshop.companyName
})
</script>

<template>
  <footer class="sbo-footer st-flex-center-between">
    <div class="sbo-footer__left-controls">
      <SBOIdleTimerBar />
      <div class="sbo-footer__left-controls__info">
        <div>
          <span class="sbo-footer__info__label">{{ $t('backoffice_version_label') }}: </span
          ><span>1.85.0-0.alpha (B: 7344858d6)</span>
        </div>
        <div>
          <span class="sbo-footer__info__label">{{ $t('backoffice_terminal_id') }}: </span
          ><span>{{ tenantName }} ({{ appRunUuid }})</span>
        </div>
      </div>
    </div>
    <div class="sbo-footer__right-controls">
      <NXGRetailClock />
    </div>
  </footer>
</template>
<style scoped lang="scss">
.sbo-footer {
  font-family: var(--nxgds-alias-type-terminal-caption-strong-font-family);
  background: var(--nxgds-mapped-color-surface-component-card-default);
  border-top: 1px solid var(--nxgds-mapped-color-border-component-page);

  &__left-controls {
    display: flex;
    align-items: center;
  }

  &__left-controls__info {
    display: flex;
    flex-direction: column;
    color: var(--nxgds-mapped-color-text-primary);
    padding: 0 var(--nxgds-alias-spacing-xs);
    font-weight: var(--nxgds-alias-type-terminal-caption-strong-weight);
    font-size: var(--nxgds-alias-type-terminal-caption-strong-size);
    line-height: var(--nxgds-alias-type-terminal-caption-strong-line-height);
    letter-spacing: var(--nxgds-alias-type-terminal-caption-strong-letter-spacing);
  }

  &__info__label {
    color: var(--nxgds-mapped-color-text-secondary);
  }

  &__right-controls {
    padding: 0 var(--nxgds-alias-spacing-xs);
  }
}
</style>
